/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type SearchClassifyResponseClassifiersItem1 = typeof SearchClassifyResponseClassifiersItem1[keyof typeof SearchClassifyResponseClassifiersItem1];


export const SearchClassifyResponseClassifiersItem1 = {
  NUMBER_0: 0,
  NUMBER_1: 1,
} as const;
